import React from 'react';
import DataList from '../DataList';
import { getAdmissionGrades, deleteAdmissionGrade, bulkDeleteAdmissionGrades, bulkUploadAdmissionGrades } from '../../api/data';

const AdmissionGradesList: React.FC = () => {
  const config = {
    title: 'Admission Grades',
    singularName: 'admission grade',
    columns: [
      { key: 'id', label: 'ID' },
      { key: 'program_name_ar', label: 'Program (AR)' },
      { key: 'year', label: 'Year' },
      { key: 'grade', label: 'Grade' },
      { key: 'admission_type', label: 'Type' },
      { key: 'track', label: 'Track' }
    ],
    fetchData: getAdmissionGrades,
    deleteItem: deleteAdmissionGrade,
    bulkDelete: bulkDeleteAdmissionGrades,
    bulkUpload: bulkUploadAdmissionGrades,
    createRoute: '/data/admission-grades/create',
    editRoute: (id: number) => `/data/admission-grades/${id}/edit`
  };

  return <DataList config={config} />;
};

export default AdmissionGradesList;
